<template>
<transition name="scale">
<div class="ui pointing red tiny basic label">
<slot></slot>
</div>
</transition>
</template>

<script>
'use strict';
export default {
  name: 'errmsg',
}
</script>




// WEBPACK FOOTER //
// errmsg.vue?09c8f804